<div class="loader">
    <div class="center loader__content">
        <div class="animation">
            <div class="background"></div>
            <div class="bottom"></div>
            <div class="top"></div>
        </div>

        <div class="loader__content__title">
            <h2 class="loader__content__title__text" *ngIf="message">
                {{ message }}
            </h2>
            <div class="loader__content__title__status" *ngIf="status">Status: {{ status }}</div>
            <div class="loader__content__title__time" *ngIf="eta">Estimated Time: {{ eta }}</div>
        </div>
        <img src="/assets/images/lenai.svg" alt="Powered by LenAI" />
    </div>
</div>
